/* Generated. This file cannot be edited directly. Please check codegen.ts for configuration. */
// @ts-nocheck

import { gql } from '@apollo/client'
import { VehicleIconLinkVehicleFragmentDoc } from '../../../../../alert-cards-common/src/lib/VehicleIconLink/vehicleIconLink.hook'
import * as Types from '../../../../../graphql/src/lib/graphql/generated/types'
import {
  MetaPhoneDriverEmployeeFragmentDoc,
  MetaPhoneDriverVehicleFragmentDoc,
} from '../MetaPhoneDriver/metaPhoneDriver.hook'
export type DefaultMetaInProgressAlertVehicleFragment = {
  __typename?: 'Vehicle'
  totalPassengersInVehicle: number | null
  id: string
  inService: boolean | null
  label: number | null
  hardwareConfiguration: {
    __typename?: 'HardwareConfiguration'
    tablet: { __typename?: 'Tablet'; phoneNumber: string | null } | null
  } | null
}

export type DefaultMetaInProgressAlertEmployeeFragment = {
  __typename?: 'Employee'
  id: string
  firstName: string | null
  lastName: string | null
}

export const DefaultMetaInProgressAlertVehicleFragmentDoc = gql`
    fragment DefaultMetaInProgressAlertVehicle on Vehicle {
  totalPassengersInVehicle
  ...MetaPhoneDriverVehicle
  ...VehicleIconLinkVehicle
}
    ${MetaPhoneDriverVehicleFragmentDoc}
${VehicleIconLinkVehicleFragmentDoc}`
export const DefaultMetaInProgressAlertEmployeeFragmentDoc = gql`
    fragment DefaultMetaInProgressAlertEmployee on Employee {
  ...MetaPhoneDriverEmployee
}
    ${MetaPhoneDriverEmployeeFragmentDoc}`
